module.exports = __webpack_public_path__ + "media/standardized_tests/financial_aid_icon-af47b682.jpg";